export const PIXEL_GAP = 224;

export const PIXEL_SCALE = 1.3;

export const PIXEL_SCALE_MOUSE = 1.2;

export const KeysPosition = {
    "ESC": { x: -32, y: -353, h: 15, w: 16 },
    "F1": { x: -64, y: -353, h: 15, w: 16 },
    "1": { x: -64, y: -369, h: 15, w: 16 },
    "Q": { x: -64, y: -385, h: 15, w: 16 },
    "A": { x: -64, y: -401, h: 15, w: 16 },
    "Z": { x: -64, y: -417, h: 15, w: 16 },
    "F2": { x: -80, y: -353, h: 15, w: 16 },
    "2": { x: -80, y: -369, h: 15, w: 16 },
    "W": { x: -80, y: -385, h: 15, w: 16 },
    "S": { x: -80, y: -401, h: 15, w: 16 },
    "X": { x: -80, y: -417, h: 15, w: 16 },
    "F3": { x: -96, y: -353, h: 15, w: 16 },
    "3": { x: -96, y: -369, h: 15, w: 16 },
    "E": { x: -96, y: -385, h: 15, w: 16 },
    "D": { x: -96, y: -401, h: 15, w: 16 },
    "C": { x: -96, y: -417, h: 15, w: 16 },
    "F4": { x: -112, y: -353, h: 15, w: 16 },
    "4": { x: -112, y: -369, h: 15, w: 16 },
    "R": { x: -112, y: -385, h: 15, w: 16 },
    "F": { x: -112, y: -401, h: 15, w: 16 },
    "V": { x: -112, y: -417, h: 15, w: 16 },
    "F5": { x: -128, y: -353, h: 15, w: 16 },
    "5": { x: -128, y: -369, h: 15, w: 16 },
    "T": { x: -128, y: -385, h: 15, w: 16 },
    "G": { x: -128, y: -401, h: 15, w: 16 },
    "B": { x: -128, y: -417, h: 15, w: 16 },
    "F6": { x: -144, y: -353, h: 15, w: 16 },
    "6": { x: -144, y: -369, h: 15, w: 16 },
    "Y": { x: -144, y: -385, h: 15, w: 16 },
    "H": { x: -144, y: -401, h: 15, w: 16 },
    "N": { x: -144, y: -417, h: 15, w: 16 },
    "F7": { x: -160, y: -353, h: 15, w: 16 },
    "7": { x: -160, y: -369, h: 15, w: 16 },
    "U": { x: -160, y: -385, h: 15, w: 16 },
    "J": { x: -160, y: -401, h: 15, w: 16 },
    "M": { x: -160, y: -417, h: 15, w: 16 },
    "F8": { x: -176, y: -353, h: 15, w: 16 },
    "8": { x: -176, y: -369, h: 15, w: 16 },
    "I": { x: -176, y: -385, h: 15, w: 16 },
    "K": { x: -176, y: -401, h: 15, w: 16 },
    "F9": { x: -192, y: -353, h: 15, w: 16 },
    "9": { x: -192, y: -369, h: 15, w: 16 },
    "O": { x: -192, y: -385, h: 15, w: 16 },
    "L": { x: -192, y: -401, h: 15, w: 16 },
    "F10": { x: -206, y: -353, h: 15, w: 16 },
    "0": { x: -206, y: -369, h: 15, w: 16 },
    "P": { x: -206, y: -385, h: 15, w: 16 },
    "F11": { x: -222, y: -353, h: 15, w: 16 },
    "F12": { x: -236, y: -353, h: 15, w: 16 },
    "TAB": { x: -36, y: -385, h: 15, w: 26 },
    "CAPS_LOCK": { x: -36, y: -401, h: 15, w: 26 },
    "SHIFT": { x: -36, y: -417, h: 15, w: 26 },
    "CTRL": { x: -36, y: -433, h: 15, w: 26 },
    "ALT": { x: -68, y: -433, h: 15, w: 26 },
    "ENTER": { x: -244, y: -401, h: 15, w: 26 },
    "DELETE": { x: -260, y: -369, h: 15, w: 26 },
    "LEFT": { x: -304, y: -433, h: 15, w: 16 },
    "UP": { x: -320, y: -417, h: 15, w: 16 },
    "DOWN": { x: -320, y: -433, h: 15, w: 16 },
    "RIGHT": { x: -336, y: -433, h: 15, w: 16 },
    "MOUSE": { x: -1063, y: -1, h: 30, w: 18 },
    "MOUSE_RIGHT_CLICK": { x: -1063, y: -33, h: 30, w: 18 },
    "MOUSE_LEFT_CLICK": { x: -1095, y: -1, h: 30, w: 18 },
    "MOUSE_FULL_CLICK": { x: -1095, y: -33, h: 30, w: 18 },

}